import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Loading01 = function Loading01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 2.25v2.5M12 18v4M5.75 12h-3.5m19 0h-1.5m-1.2929 6.4571L17.75 17.75m.9142-12.3342L17.25 6.83M4.9216 19.0784 7.75 16.25M5.1287 5.2087 7.25 7.33"
    })
  }));
};
export default Loading01;